import React from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Container, Button } from "react-bootstrap";

const OrderConfirmationPage = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const order = location.state?.order;

  if (!order) {
    return (
      <Container className="py-5 text-center">
        <h3>Invalid Access</h3>
        <p>No order found.</p>
        <Button onClick={() => navigate("/products")}>Back to Products</Button>
      </Container>
    );
  }

  return (
    <Container className="py-5 text-center">
      <h3> Order Placed!</h3>
      <p>
        Your order for <strong>{order.product_name}</strong> has been placed.
        Please wait while the seller confirms it.
      </p>
      <Button variant="primary" onClick={() => navigate("/dashboard")}>
        Go to Dashboard
      </Button>
      
    </Container>
  );
};

export default OrderConfirmationPage;
